/**
 * Reads a cap field off low-freq market data.
 */
const readCapAmount = (value) => {
    if (value === undefined || value.trim() === '')
        return null;
    const amount = parseFloat(value);
    return Number.isFinite(amount) ? amount : null;
};
/**
 * Whether a market has no borrow capacity left.
 */
export const isMarketBorrowCapReached = (marketLow) => {
    const allowedBorrow = readCapAmount(marketLow === null || marketLow === void 0 ? void 0 : marketLow.allowed_borrow_amount);
    return allowedBorrow !== null && allowedBorrow <= 0;
};
/**
 * Whether a market has no supply capacity left.
 */
export const isMarketSupplyCapReached = (marketLow) => {
    const allowedSupply = readCapAmount(marketLow === null || marketLow === void 0 ? void 0 : marketLow.allowed_supply_amount);
    return allowedSupply !== null && allowedSupply <= 0;
};
